/**
 * @flow
 * @relayHash 9176ae30b3596466458be941ae49b884
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PasswordResetEmailInput = {|
  email: string,
  clientMutationId?: ?string,
  revisionMessage?: ?string,
|};
export type ResetPasswordEmailMutationVariables = {|
  input: PasswordResetEmailInput
|};
export type ResetPasswordEmailMutationResponse = {|
  +mePasswordResetEmail: ?{|
    +viewer: ?{|
      +id: string,
      +me: ?{|
        +isAuthenticated: ?boolean
      |},
    |},
    +errors: ?$ReadOnlyArray<?{|
      +code: ?string,
      +location: ?string,
      +message: string,
    |}>,
  |}
|};
export type ResetPasswordEmailMutation = {|
  variables: ResetPasswordEmailMutationVariables,
  response: ResetPasswordEmailMutationResponse,
|};
*/


/*
mutation ResetPasswordEmailMutation(
  $input: PasswordResetEmailInput!
) {
  mePasswordResetEmail(input: $input) {
    viewer {
      id
      me {
        isAuthenticated
        id
      }
    }
    errors {
      code
      location
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PasswordResetEmailInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAuthenticated",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "code",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ResetPasswordEmailMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "mePasswordResetEmail",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PasswordResetEmailPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "viewer",
            "storageKey": null,
            "args": null,
            "concreteType": "Query",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "me",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ResetPasswordEmailMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "mePasswordResetEmail",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PasswordResetEmailPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "viewer",
            "storageKey": null,
            "args": null,
            "concreteType": "Query",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "me",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "ResetPasswordEmailMutation",
    "id": null,
    "text": "mutation ResetPasswordEmailMutation(\n  $input: PasswordResetEmailInput!\n) {\n  mePasswordResetEmail(input: $input) {\n    viewer {\n      id\n      me {\n        isAuthenticated\n        id\n      }\n    }\n    errors {\n      code\n      location\n      message\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c0376715b4aaf05c40126a87e32dcf69';
module.exports = node;
